module.exports = __webpack_public_path__ + "static/media/logo.6219d29b.png";